const WP_BASE = "https://5igsolutions.com/wp/wp-json/wp/v2";
const WP_SITE = "https://5igsolutions.com/wp";

function cleanDiviShortcodes(html = "") {
  // Quita shortcodes tipo [et_pb_...] y [/et_pb_...]
    return String(html).replace(/\[\/?et_pb[^\]]*\]/g, "");
}


export async function getPosts({
  page = 1,
  perPage = 6,
  search = "",
  categoryId = null,
} = {}) {
  const params = new URLSearchParams({
    _embed: "1",
    status: "publish",
    per_page: String(perPage),
    page: String(page),
    orderby: "date",
    order: "desc",
  });

  if (search?.trim()) params.append("search", search.trim());
  if (categoryId) params.append("categories", String(categoryId));

  const url = `${WP_BASE}/posts?${params.toString()}`;

  const res = await fetch(url);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`WP API error ${res.status}: ${text}`);
  }

  const posts = await res.json();
  const totalPages = Number(res.headers.get("X-WP-TotalPages") || 1);
  const total = Number(res.headers.get("X-WP-Total") || posts.length);

  return { posts, totalPages, total };
}


export async function getPostBySlug(slug) {
    const url = `${WP_BASE}/posts?slug=${encodeURIComponent(slug)}&_embed&status=publish`;

    const res = await fetch(url);
    if (!res.ok) {
        const text = await res.text();
        throw new Error(`WP API error ${res.status}: ${text}`);
    }

    const arr = await res.json();
    const post = arr?.[0];

    if (!post) {
        throw new Error("Post no encontrado");
    }

    const image = post?._embedded?.["wp:featuredmedia"]?.[0]?.source_url || null;

    return {
        id: post.id,
        slug: post.slug,
        title: post.title?.rendered || "",
        excerpt: cleanDiviShortcodes(post.excerpt?.rendered || ""),
        content: cleanDiviShortcodes(post.content?.rendered || ""),
        date: post.date,
        image,
        categories: post.categories || [],
    }; 
}

export async function getCommentsByPostId(postId, { perPage = 50 } = {}) {
    const url = `${WP_BASE}/comments?post=${postId}&per_page=${perPage}&order=asc&orderby=date`;

    const res = await fetch(url);
    if (!res.ok) {
        const text = await res.text();
        throw new Error(`WP API error ${res.status}: ${text}`);
    }

    const comments = await res.json();

    return comments.map((c) => ({
        id: c.id,
        post: c.post,
        authorName: c.author_name,
        date: c.date,
        content: c.content?.rendered || "",
        status: c.status, 
    }));
}

export async function submitWpComment({
    postId,
    authorName,
    authorEmail,
    authorUrl = "",
    content,
    }) {
    const url = `${WP_SITE}/wp-comments-post.php`;

    const form = new URLSearchParams();
    form.append("comment_post_ID", String(postId));
    form.append("author", authorName || "");
    form.append("email", authorEmail || "");
    form.append("url", authorUrl || "");
    form.append("comment", content || "");

    const res = await fetch(url, {
        method: "POST",
        headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        },
        body: form.toString(),
        credentials: "omit",
        mode: "cors",
        redirect: "follow",
    });

    if (!res.ok) {
        const text = await res.text();
        throw new Error(`No se pudo enviar comentario (${res.status}). ${text}`);
    }

    return true;
}

// ===== Featured / destacados =====
function mapWpPostToCard(p) {
    const image = p?._embedded?.["wp:featuredmedia"]?.[0]?.source_url || null;

    return {
        id: p.id,
        slug: p.slug,
        title: p.title?.rendered || "",
        excerpt: cleanDiviShortcodes(p.excerpt?.rendered || ""),
        date: p.date,
        image,
    };
}

function shuffle(arr) {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

export async function getFeaturedPosts({ perPage = 6 } = {}) {
  // 1) Sticky posts (destacados en WP)
    const stickyUrl = `${WP_BASE}/posts?_embed&status=publish&sticky=true&per_page=${perPage}&orderby=date&order=desc`;

    let res = await fetch(stickyUrl);
    if (res.ok) {
        const stickyPosts = await res.json();
        if (Array.isArray(stickyPosts) && stickyPosts.length > 0) {
            return stickyPosts.map(mapWpPostToCard);
        }
    }

  // 2) Fallback: últimos posts y escogemos algunos (mezclados)
    const fallbackUrl = `${WP_BASE}/posts?_embed&status=publish&per_page=12&page=1&orderby=date&order=desc`;

    res = await fetch(fallbackUrl);
    if (!res.ok) {
        const text = await res.text();
        throw new Error(`WP API error ${res.status}: ${text}`);
    }

    const latest = await res.json();
    const picked = shuffle(latest).slice(0, perPage);

    return picked.map(mapWpPostToCard);
}

//FILTROS por categoria//
export async function getCategories({ perPage = 100 } = {}) {
  const url = `${WP_BASE}/categories?per_page=${perPage}&hide_empty=true&orderby=count&order=desc`;

  const res = await fetch(url);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`WP API error ${res.status}: ${text}`);
  }

  const cats = await res.json();
  return cats.map((c) => ({
    id: c.id,
    name: c.name,
    slug: c.slug,
    count: c.count,
  }));
}

export async function getRelatedPosts({ 
  categoryIds = [], 
  excludeId = null, 
  perPage = 3 
} = {}) {

  if (!categoryIds.length) return [];

  const params = new URLSearchParams({
    _embed: "1",
    status: "publish",
    per_page: String(perPage),
    categories: categoryIds.join(","), 
    orderby: "date",
    order: "desc",
  });

  const url = `${WP_BASE}/posts?${params.toString()}`;

  const res = await fetch(url);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`WP API error ${res.status}: ${text}`);
  }

  const posts = await res.json();

  return posts
    .filter(p => p.id !== excludeId)
    .slice(0, perPage)
    .map(mapWpPostToCard);
}

